import { create } from "zustand";
import { getData } from "../utils/formHelpers";
import { SamplingProcedureType } from "../../app/types/genericTables.types";

type UseSamplingProcedureType = {
  samplingProcedureList: SamplingProcedureType[];
  get: (id: SamplingProcedureType["id"]) => SamplingProcedureType | undefined;
  query: string;
  setQuery: (query: string) => void;
  fetchAll: () => void;
  loading: boolean;
};

export const useSamplingProcedMuestreo = create<UseSamplingProcedureType>(
  (set, get) => ({
    loading: false,
    samplingProcedureList: [],
    query: "",
    setQuery: (query) => set({ query }),
    get: (id) =>
      get().samplingProcedureList.find((sampling) => sampling.id === id),
    fetchAll: async () => {
      set({ loading: true });
      try {
        const endpoint = "/generic/ProcedMuestreo";
        const { data: response } = await getData(endpoint);
        set(() => ({
          samplingProcedureList: response,
          loading: false,
        }));
      } catch (error) {
        console.error("Error fetching analysisTypeList:", error);
        set({ loading: false });
      }
    },
  })
);
